<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { useFlickitySlider } from '../../composables/use-flickity-slider'
import { useImgSrcSet } from '../../composables/use-img-src-set'

import type { Brand } from '@xcel-next/core/enums'
import type { ComposedMenu } from '@xcel-next/composer-schema'

const props = withDefaults(defineProps<{
  additionalMenu?: ComposedMenu,
  brand?: Brand
}>(), {
  additionalMenu: () => []
})

const flickityDiv = ref<HTMLElement | null>(null)
const { sliderControlDescription, initFlickitySlider, keepTabbingFocusInSlider } = useFlickitySlider(flickityDiv)
const { createImgSrc } = useImgSrcSet()

const imageIconUrl = (iconData: NonNullable<ComposedMenu[number]['icon']>) =>
  createImgSrc({
    image: iconData,
    brand: props.brand ?? '',
    type: 'webp',
    setName: 'hotGossipImage'
  }) ?? undefined

onMounted(async () => {
  flickityDiv.value?.classList.add('bx-js-enabled')

  try {
    await initFlickitySlider()
  } catch (error) {
    flickityDiv.value?.classList.remove('bx-js-enabled')
    throw error
  }
})
</script>

<template>
  <div id="hot-gossip-flickity-0"
       ref="flickityDiv"
       :aria-label="`Populäre Inhalte Karusell: ${additionalMenu.length} Inhalte. ${sliderControlDescription}`"
       class="bx-teaser-container bx-teaser-container--hot-gossip bx-hot-gossip bx-slider bx-slider--hot-gossip bx-typo--hot-gossip"
       @keydown.enter="keepTabbingFocusInSlider()">
    <div v-for="(item, index) in additionalMenu"
         :id="`bx-js-hot-gossip-slider-cell-${index}`"
         :key="index"
         class="bx-slider__cell"
         :data-cell-index="index">
      <a :href="item.url"
         :target="item.target"
         class="bx-hot-gossip__content">
        <figure v-if="item.icon && item.icon.imageId"
                class="bx-hot-gossip__image">
          <img :src="imageIconUrl(item.icon)"
               :width="item.icon.width"
               :height="item.icon.height"
               :title="item.icon.seoName"
               :alt="item.icon.imageAltText">
        </figure>
        <span v-if="item.name"
              class="bx-hot-gossip__headline">
          {{ item.name }}
        </span>
      </a>
    </div>
  </div>
</template>
